<template lang="html">
	<div class="item-view">
		<p v-if="computedItemCategories.length>0">Bitte wähle aus den verfügbaren Angeboten die gewünschte Anzahl aus:</p>
		<b v-else>Zum angegebenen Zeitpunkt konnten keine Objekte in der ausgewählten Filiale gefunden werden</b>
		<div 
			class="buttons has-addons" 
			v-if="itemMajorCategories.length>1">
			<button 
				class="button" 
				:class="{'is-secondary': !isCurrentMajorCategory(category), 'is-primary': isCurrentMajorCategory(category)}" 
				v-for="category in itemMajorCategories" 
				@click="setItemMajorCategory(category)">{{ category.name }}</button>
		</div>
		<item-list 
			:value="computedItemCategories" 
			@save="saveItems" 
			edit/>
		<div class="text-right">
			<div class="buttons has-addons is-right">
				<button 
					class="button is-secondary" 
					@click="$emit('previous')">Zurück</button>
				<button 
					class="button is-primary" 
					@click="$emit('next')" 
					:disabled="positions.length===0">Weiter</button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ItemList from '../components/ItemList.vue'
import InputSelect from '../components/InputSelect.vue'

export default {
	name: 'ItemView',
	components: {
		InputSelect,
		ItemList
	},
	data() {
		return {
			itemMajorCategory: null,
			computedItemCategories: []
		}
	},
	computed: {
		...mapGetters('itemCategory', ['itemMajorCategories']),
		...mapState('itemCategory', ['itemCategories']),
		...mapState('order', ['positions'])
	},
	created() {
		this.$store.dispatch('itemCategory/findAll')
		this.computeItemCategories()
	},
	watch: {
		itemCategories() {
			this.computeItemCategories()
		}
	},
	methods: {
		computeItemCategories() {
			this.computedItemCategories = this.itemCategories
				.filter(category => {
					if (
						this.itemMajorCategory &&
						category.ItemMajorCategory.id === this.itemMajorCategory.id
					)
						return true
					if (!this.itemMajorCategory) return true
					return false
				})
				.map(category => {
					const c = Object.assign({}, category)
					const position = this.positions.find(c => c.id === category.id)
					c.amount = position ? position.amount : 0
					return c
				})
		},
		setItemMajorCategory(category) {
			if (this.itemMajorCategory && this.itemMajorCategory.id === category.id)
				this.itemMajorCategory = null
			else this.itemMajorCategory = category
			this.computeItemCategories()
		},
		isCurrentMajorCategory(category) {
			if (!this.itemMajorCategory) return false
			if (this.itemMajorCategory.id === category.id) return true
			return false
		},
		saveItems() {
			const positions = []
			this.computedItemCategories.forEach(category => {
				if (category.amount > 0) positions.push(Object.assign({}, category))
			})
			this.$store.commit('order/SET_POSITIONS', positions)
			this.$store.dispatch('order/calculatePrice')
		}
	}
}
</script>

<style lang="css">
</style>
